import React, { useState, useRef, useEffect } from "react";
import TextField from "@mui/material/TextField";
import { useSharedCrm } from "../../itemPage/sharedCrmContext";
import { useSelector } from "react-redux";
const filterered = (data, matchCustomer, field) => {
  let result = null;
  if (field === "GuestCode") {
    result = data?.find(guest => guest?.customerCode === matchCustomer?.customerCode);
    if (result) {
      return {
        ...result,
        GuestCode: matchCustomer.GuestCode
      };
    }
    
  } else if (field === "PhoneNo" || field === "CustomerName") {
    result = data?.find(guest => guest?.CustomerCode === matchCustomer?.customerCode);
  }
  return result || matchCustomer;
};

export const DropdownSelectOnly = ({ field, onChange,customer, disabled }) => {
  const { formData,formDataError, searchValue, setSearchValue,handleMainSelect,setFormDataError } = useSharedCrm();
  const [open, setOpen] = useState(false);
  const { CustomerMaster } = useSelector((state) => state.CustomerMaster);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (formData[field.field]) {
      setSearchValue(prev => ({
        ...prev,
        [field.field]: formData[field.field]?.toString() || "",
      }));
    }
  }, [formData]);

  useEffect(() => {
    const term = (searchValue[field.field] || "").toString().toLowerCase();
    const filtered = field.options.filter((item) =>
      item[field.searchValue]?.toString().toLowerCase().includes(term)
    );
    setFilteredOptions(filtered);
  }, [searchValue[field.field], field.options]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
        handleBlur();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const updateSearchValue = (val) => {
    setSearchValue((prev) => ({ ...prev, [field.field]: val }));
  };
    const handleSelect = (item) => {
      const value = item[field.searchValue];
      const selectedValue = field.selectedValues; 
      const fieldName = field.field;
      setFormDataError({});
      updateSearchValue(value);
      setFormDataError((prevErrors) => ({
        ...prevErrors,
        [field.field ]: "", // Clear error for this field
      }));
      const matchingdata=filterered((CustomerMaster||customer),item,"GuestCode");
      handleMainSelect(selectedValue,fieldName, matchingdata);
      setOpen(false);
    };
  const handleBlur = () => {
    const input = String(searchValue[field.field] || "").trim().toLowerCase();
    const match = field.options.find(item => {
      const value = String(item[field.searchValue] || "").toLowerCase();
      return value === input;
    });
  
    if (!match && !field.allowCustomInput) {
      // onChange(field.field, null);
    } else if (match) {
      // onChange(field.field, match[field.searchValue]);
    }
  };
  
  // const handleBlur = () => {
  //   const input = searchValue[field.field]?.trim().toLowerCase();

  //   const match = field.options.find(item => {
  //     const value = item[field.searchValue]?.toString().toLowerCase();
  //     return value === input;
  //   });
  
  //   console.log("Input:", input);
  //   console.log("Matched value:", match);
  //   console.log("field.options :", field.options);
  //   if (!match) {
  //     setFormErrors(prev => ({
  //       ...prev,
  //       [field.field]: field.message || "Please select a valid option",
  //     }));
  //     // onChange(field.field, null);
  //   } else {
  //     onChange(field.field, match[field.searchValue]);
  //   }
  // };
//  console.log("fromerrors :", searchValue);

  return (
    <div ref={dropdownRef} className="customer-creation-textfield Customer-ErrorDiv">
      <TextField
        label={field.label}
        variant="standard"
        value={searchValue[field.field] || ""}
        onChange={(e) => updateSearchValue(e.target.value)}
        onClick={() => setOpen(true)}
        onBlur={handleBlur}
        error={!!formDataError[field.field]}
        helperText={formDataError[field.field]}
        autoComplete="off"
        className="customer-textfield"
        disabled={disabled}
      />
      {open && (
        <ul className="custom-dropdown">
          {filteredOptions.length > 0 ? (
            filteredOptions.map((item, idx) => (
              <li
                key={idx}
                onMouseDown={() => handleSelect(item)}
                className="dropdown-item"
              >
                {field.getDisplayValue
                  ? field.getDisplayValue(item)
                  : item[field.searchValue]}
              </li>
            ))
          ) : (
            <li className="dropdown-item disabled">
              {field.message || "No options found"}
            </li>
          )}
        </ul>
      )}
    </div>
  );
};

export const DropdownWithCustomInput = ({ field, disabled }) => {
  const {
    formData, setFormData,
    formDataError, setFormDataError,
    searchValue, setSearchValue,
    handleMainChange, handleMainSelect,
  } = useSharedCrm();

  const { fetchGuestCode } = useSelector((state) => state.greeterData);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  const updateSearchValue = (val) => {
    setSearchValue((prev) => ({ ...prev, [field.field]: val }));
  };

  // --- Sync formData -> searchValue (field-specific only) ---
  useEffect(() => {
    if (formData[field.field] !== undefined) {
      updateSearchValue(formData[field.field]?.toString() || "");
    }
  }, [formData[field.field]]);
  // --- Filter options (with debounce optional) ---
  useEffect(() => {
    const term = (searchValue[field.field] || "").toLowerCase();
    const filtered = field.options
      ?.filter((item) => {
        if (field.field === "PhoneNo") {
          return (item?.phoneNum || "")
            .toString()
            .toLowerCase()
            .includes(term);
        } else if (field.field === "CustomerName") {
          const name = item?.customerName?.toLowerCase() || "";
          const code = item?.customerCode?.toLowerCase() || "";
          return name.includes(term) || code.includes(term);
        } else {
          const displayValue = field.getDisplayValue
            ? field.getDisplayValue(item)
            : item?.[field.searchValue] || "";
          return displayValue.toLowerCase().includes(term);
        }
      })
      .slice(0, 1000);
      
    setFilteredOptions(filtered);
    if (filtered.length === 0) {
      setOpen(false);
     setFormData((prev) => ({ ...prev, existingcust: "NO",CustomerCode:"" }));
    }
  }, [searchValue[field.field], field.options]);

  // --- Close dropdown when clicking outside ---
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  const handleSelect = (item) => {
    const value = item[field.searchValue];
    const fieldName = field.field;
    let dataToPass = item;
    setFormDataError({});
    if (fieldName === "PhoneNo" || fieldName === "CustomerName") {
      const matchedGuest = filterered(fetchGuestCode, item, fieldName); // <-- Fix this helper
      dataToPass = { ...item, GuestCode: matchedGuest?.GuestCode ?? "" };
    }
    updateSearchValue(value);
    handleMainSelect(field.selectedValues, fieldName, dataToPass);
    setOpen(false);
  };
  const handleChange = (e) => {
    const value = e.target.value;
    setOpen(true);
    updateSearchValue(value);
    setFormDataError((prev) => ({ ...prev, [field.field]: "" }));
    if (value === "") {
      updateSearchValue("");
      setFormData((prev) => ({
        ...prev,
        PhoneNo: "",
        CustomerName: "",
        CustomerCode: "",
        GreeterCode: "",
      }));
      setOpen(false);
      return;
    }
    if (field.field === "PhoneNo" && (!/^\d*$/.test(value) || value.length > 10)) {
      return; 
    }
    
   
  };
  return (
    <div ref={dropdownRef} className="customer-creation-textfield Customer-ErrorDiv">
      <TextField
        label={field.label}
        variant="standard"
        value={searchValue[field.field] || ""}
        onChange={(e)=>{handleChange(e)}}
        onBlur={() => handleMainChange(field, searchValue[field.field])}
        onClick={() => setOpen(true)}
        error={!!formDataError[field.field]}
        helperText={formDataError[field.field]}
        autoComplete="off"
        disabled={disabled}
        className="customer-textfield"
      />

      {open && filteredOptions.length > 0 && (
        <ul className="custom-dropdown" role="listbox">
          {filteredOptions.map((item, idx) => (
            <li
              key={idx}
              onClick={() => handleSelect(item)}
              role="option"
              className="dropdown-item"
            >
              {field.getDisplayValue
                ? field.getDisplayValue(item)
                : item[field.searchValue]}
            </li>
          ))}
        </ul>
      )}

      {open && filteredOptions.length === 0 && (
        <ul className="custom-dropdown">
          <li className="dropdown-item disabled">
            {field.message || "No options found"}
          </li>
        </ul>
      )}
    </div>
  );
};

// export const DropdownWithCustomInput = ({ field, disabled }) => {
//   const { formData,setFormData,formDataError, setFormDataError, searchValue, setSearchValue, handleMainChange ,handleMainSelect} = useSharedCrm();
//   const [open, setOpen] = useState(false);
//   const { fetchGuestCode } = useSelector((state) => state.greeterData);
//   const [filteredOptions, setFilteredOptions] = useState([]);
//   const dropdownRef = useRef(null);
//   const updateSearchValue = (val) => {
//     setSearchValue((prev) => ({ ...prev, [field.field]: val }));
//   };
  
//   useEffect(() => {
//     if (formData[field.field]) {
//       setSearchValue(prev => ({
//         ...prev,
//         [field.field]: formData[field.field]?.toString() || "",
//       }));
//     }
//   }, [formData]);
//   // useEffect(() => {
//   //   const term = (searchValue[field.field] || "").toLowerCase();
//   //   const filtered = field.options
//   //     .filter((item) => {
//   //       const displayValue = field.getDisplayValue
//   //         ? field.getDisplayValue(item)
//   //         : item?.[field.searchValue] || "";
//   //       return displayValue.toLowerCase().includes(term);
//   //     })
//   //     .slice(0, 1000); // Limit to first 1000 matches
//   //   setFilteredOptions(filtered);
//   //   if(filtered?.length===0){
//   //     setFormData((prev) => ({
//   //       ...prev,
//   //       existingcust: "NO",
//   //     }));
//   //   }
//   // }, [searchValue[field.field], field.options]);
//   useEffect(() => {
//     const term = (searchValue[field.field] || "").toLowerCase();
//     const filtered = field.options
//       .filter((item) => {
//         let displayValue = "";
//         if (field.field === "PhoneNo") {
//           displayValue = item?.phoneNum?.toString() || "";
//           return displayValue.toLowerCase().includes(term);
//         } else if (field.field === "CustomerName") {
//           const name = item?.customerName?.toLowerCase() || "";
//           const code = item?.customerCode?.toLowerCase() || "";
//           return name.includes(term) || code.includes(term);
//         }
//         // else {
//         //   displayValue = field.getDisplayValue
//         //     ? field.getDisplayValue(item)
//         //     : item?.[field.searchValue] || "";
//         //   return displayValue.toLowerCase().includes(term);
//         // }
//       })
//       .slice(0, 1000); 
//     setFilteredOptions(filtered);
//     if (filtered?.length === 0) {
//       setFormData((prev) => ({
//         ...prev,
//         existingcust: "NO",
//       }));
//     }
//   }, [searchValue[field.field], field.options]);
  
  

//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
//         setOpen(false);
//         // handleBlur();
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);
//   const handleSelect = (item) => {
//     const value = item[field.searchValue];
//     const selectedValue = field.selectedValues; 
//     let dataToPass = item;
//     const fieldName = field.field;
//     setFormDataError({});
//     if(fieldName==="PhoneNo"||fieldName==="CustomerName"){
//       const matchedGuest =filterered(fetchGuestCode,item,fieldName)
//       dataToPass = {
//         ...item,
//         GuestCode: matchedGuest?.GuestCode ?? "", 
//       };
//     }

//     updateSearchValue(value);
//     handleMainSelect(selectedValue,fieldName, dataToPass);
//     setOpen(false);
//   };

//   const handleChange = (e) => {
//     const value = e.target.value;
//     setFormDataError((prevErrors) => ({
//       ...prevErrors,
//       [field.field ]: "", // Clear error for this field
//     }));
//     if (value === "") {
//       updateSearchValue("");
//       setFormData((prevData) => ({
//         ...prevData,
//         PhoneNo: "",
//         CustomerName:"",
//         CustomerCode:"",
//         GreeterCode:""
//       }));
//       setSearchValue("")
//       setOpen(false);
//     }
//      if (field.field === "PhoneNo") {
//       if (/^\d*$/.test(value) && value.length <= 10) {
//         updateSearchValue(value);
//         setOpen(true);
//       }
//     } else {
//       updateSearchValue(value);
//       setOpen(true);
//     }
//   };

//   const handleBlur = () => {
//     handleMainChange(field, searchValue[field.field]);
//   }

//   return (
//     <div ref={dropdownRef} className="customer-creation-textfield Customer-ErrorDiv">
//       <TextField
//         label={field.label}
//         variant="standard"
//         value={searchValue[field.field] || ""}
//         onChange={handleChange}
//         onBlur={handleBlur}
//         onClick={() => setOpen(true)}
//         error={!!formDataError[field.field]}
//         helperText={formDataError[field.field]}
//         autoComplete="off"
//         disabled={disabled}
//         className="customer-textfield"
//       />
//       {open && (
//         <ul className="custom-dropdown">
//           {filteredOptions.length > 0 ? (
//             filteredOptions.map((item, idx) => (
//               <li
//                 key={idx}
//                 onClick={() => handleSelect(item)}
//                 className="dropdown-item"
//               >
//                 {field.getDisplayValue
//                   ? field.getDisplayValue(item)
//                   : item[field.searchValue]}
//               </li>
//             ))
//           ) : (
            
//             <li className="dropdown-item disabled">
//               {field.message || "No options found"}
//               {setOpen(false)}
              
//             </li>
//           )}
//         </ul>
//       )}
//     </div>
//   );
// };




















